import styleInject from '../../external_node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".purchase-confirmation-bridge.wcl-1elol4w{transition:opacity 150ms linear}.purchase-confirmation-bridge.hidden.wcl-1elol4w{opacity:0}.purchase-confirmation-bridge__iframe.wcl-1elol4w{position:absolute;top:0;left:0;width:100%;height:100%}";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=App.css.js.map
